import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const propTypes = {
  loan: PropTypes.object.isRequired,
};

const LoanFormFooter = ({ loan }) => {
  const { currentStep, steps } = loan;

  const currentStepType = steps[currentStep].type;

  if (['TERMS_CONDITIONS', 'PRODUCT'].includes(currentStepType)) {
    // Terms and conditions view has it's own custom buttons
    // Offer page is submitted automatically
    return null;
  }

  const SubmitBtn = (
    <Button isLoading={loan.isLoanSubmitting} isFullWidth>
      <FormattedMessage id="offer.submit.sign" />
    </Button>
  );

  const NextBtn = (
    <Button isLoading={loan.isLoanSubmitting} isFullWidth>
      <FormattedMessage id="navigation.next" />
    </Button>
  );

  const PrimaryButton = currentStepType !== 'SUBMIT' ? NextBtn : SubmitBtn;

  return (
    <footer className="loan-form__footer">
      {PrimaryButton}
    </footer>
  );
};

LoanFormFooter.propTypes = propTypes;

export default LoanFormFooter;
